import { apiSlice } from 'store/slices/api/api-slice';
import {
    ProductListResponse,
    ProductAddRequest,
    CreatDraftProduct,
    ProductResponse,
    ProductTitleListResponse,
} from 'types/product/product';

export const productListApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        productList: builder.query<ProductListResponse, ProductAddRequest>({
            query: (params) => ({
                url: '/product/product-list',
                method: 'GET',
                params,
            }),
        }),

        getProduct: builder.query<ProductResponse, string>({
            query: (id: string) => ({
                url: '/product/product/' + id,
                method: 'GET',
            }),
        }),

        addProduct: builder.mutation<CreatDraftProduct, CreatDraftProduct>({
            query: (creatProduct: CreatDraftProduct) => ({
                url: `/product/add-product/`,
                method: 'POST',
                body: { ...creatProduct },
            }),
        }),
        updateDraftProduct: builder.mutation<
            CreatDraftProduct,
            CreatDraftProduct
        >({
            query: (creatDraftProduct: CreatDraftProduct) => ({
                url:
                    '/product/update-draft-product/' +
                    creatDraftProduct.productId,
                method: 'PUT',
                body: { ...creatDraftProduct },
            }),
        }),

        updateActiveProduct: builder.mutation<
            CreatDraftProduct,
            CreatDraftProduct
        >({
            query: (creatDraftProduct: CreatDraftProduct) => ({
                url:
                    '/product/update-active-product/' +
                    creatDraftProduct.productId,
                method: 'PUT',
                body: { ...creatDraftProduct },
            }),
        }),

        productTitleList: builder.query<ProductTitleListResponse[], void>({
            query: () => ({
                url: '/product/product-title-list',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useLazyProductListQuery,
    useAddProductMutation,
    useLazyGetProductQuery,
    useUpdateDraftProductMutation,
    useUpdateActiveProductMutation,
    useProductTitleListQuery,
} = productListApi;
